import { JSX } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAdminRole } from './user';
import { useAuth } from '../providers/auth-provider';

export default function AdminRoute({ children }: { children: JSX.Element }) {
  const auth = useAuth();
  const location = useLocation();

  const isAdmin: boolean = isAdminRole(auth.getUser());

  if (auth.getIsLoading()) {
     return <div>Loading...</div>;
  }

  if (!auth.getIsAuthenticated() || !isAdmin) {
    return <Navigate to="/403" replace state={{ returnTo: location.pathname + location.search + location.hash }} />;
  }

  return <div style={{ flex: 1, display: 'flex', minHeight: 0, height: '100%', width: '100%'/*, backgroundColor: 'blue'*/ }}>
    {children}
  </div>;
}
